import type { Step } from 'react-joyride';

export type TourId = 'customer' | 'admin';

/**
 * Where a step wants to be. `to` is a TanStack Router path, so a route with a
 * parameter keeps its `$name` segment and the value arrives in `params`.
 */
export interface TourRoute {
  to: string;
  params?: Record<string, string>;
  search?: Record<string, string>;
}

/**
 * A Joyride step that also knows which screen it belongs to. The provider
 * navigates between screens and waits for the target before showing the step.
 */
export interface TourStep extends Step {
  route?: TourRoute;
}

/** The pathname a route lands on, with parameters filled in. */
export function pathOfRoute(route: TourRoute): string {
  return route.to
    .split('/')
    .map((segment) => (segment.startsWith('$') ? (route.params?.[segment.slice(1)] ?? segment) : segment))
    .join('/');
}

/**
 * Every element a tour can point at carries `data-tour="..."`. Steps name the
 * attribute, not a class or an id, so restyling a screen never breaks a tour.
 */
export function tourTarget(name: string): string {
  return `[data-tour="${name}"]`;
}
